import styles from "../products/analytics-table.module.css";

export default function VipStatistics({ data }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Vip Statistics</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Vip Type</th>
              <th>Total Vips</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{item._id}</td>
                <td>{item.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
